import { render, staticRenderFns } from "./Observe.vue?vue&type=template&id=fedce53e&scoped=true&"
import script from "./Observe.vue?vue&type=script&lang=js&"
export * from "./Observe.vue?vue&type=script&lang=js&"
import style0 from "./Observe.vue?vue&type=style&index=0&id=fedce53e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedce53e",
  null
  
)

export default component.exports